import { createSlice } from "@reduxjs/toolkit";
import { isBoolean } from "../../../utils/utils";
import {
  DEFAULT_VIDEO_DURATION,
  DEFAULT_VIDEO_FPS,
  DEFAULT_VIDEO_RESOLUTION,
} from "../../../utils/constants";

const commonSlice = createSlice({
  name: "commonInfo",
  initialState: {
    signUpModalOpen: false,
    affiliateRef: null,
    source: null,
    autoPlay: isBoolean(JSON.parse(localStorage.getItem("autoPlay")))
      ? JSON.parse(localStorage.getItem("autoPlay"))
      : true,
    muteVideo: isBoolean(JSON.parse(localStorage.getItem("muteVideo")))
      ? JSON.parse(localStorage.getItem("muteVideo"))
      : false,

    isModalOpened: false,
    collectionTabAnimating: false,
    videoSettings: {
      audioEnabled: localStorage.getItem("audioEnabled") === "true",
      videoResolution:
        localStorage.getItem("videoResolution") ?? DEFAULT_VIDEO_RESOLUTION,
      fps: Number(localStorage.getItem("videoFps") ?? DEFAULT_VIDEO_FPS),
      videoDuration: Number(
        localStorage.getItem("videoDuration") ?? DEFAULT_VIDEO_DURATION,
      ),
    },
  },
  reducers: {
    setSignUpModalOpen: (state, action) => {
      state.signUpModalOpen = action.payload;
    },
    setAutoPlay: (state, action) => {
      state.autoPlay = action.payload;
      localStorage.setItem("autoPlay", JSON.stringify(action.payload));
    },
    setMuteVideo: (state, action) => {
      state.muteVideo = action.payload;
      localStorage.setItem("muteVideo", JSON.stringify(action.payload));
    },
    setAffiliateRef: (state, action) => {
      state.affiliateRef = action.payload;
    },
    setSource: (state, action) => {
      state.source = action.payload;
    },
    triggerCollectionTabAnimation: (state) => {
      state.collectionTabAnimating = true;
    },
    resetCollectionTabAnimation: (state) => {
      state.collectionTabAnimating = false;
    },
    setVideoSettings: (state, action) => {
      state.videoSettings = {
        ...state.videoSettings,
        ...action.payload,
      };

      if (action.payload.audioEnabled != null) {
        localStorage.setItem(
          "audioEnabled",
          String(action.payload.audioEnabled),
        );
      }
      if (action.payload.videoResolution) {
        localStorage.setItem("videoResolution", action.payload.videoResolution);
      }
      if (action.payload.fps) {
        localStorage.setItem("videoFps", action.payload.fps);
      }
      if (action.payload.videoDuration) {
        localStorage.setItem("videoDuration", action.payload.videoDuration);
      }
    },
  },
  extraReducers: (builder) => {},
});

export const {
  setSignUpModalOpen,
  setAffiliateRef,
  setSource,
  setIsModalOpened,
  resetCollectionTabAnimation,
  setAutoPlay,
  setMuteVideo,
  triggerCollectionTabAnimation,
  setVideoSettings,
} = commonSlice.actions;

export const selectSignUpModalOpen = (state) =>
  state.commonInfo.signUpModalOpen;
export const selectAffiliateRef = (state) => state.commonInfo.affiliateRef;
export const selectSource = (state) => state.commonInfo.source;
export const selectCollectionTabAnimating = (state) =>
  state.commonInfo.collectionTabAnimating;

export const selectAutoPlay = (state) => {
  const { autoPlay } = state.commonInfo;
  const { loggedIn } = state.authInfo;
  return loggedIn ? autoPlay : true;
};

export const selectMuteVideo = (state) => state.commonInfo.muteVideo;
export const selectVideoSettings = (state) => state.commonInfo.videoSettings;

export default commonSlice.reducer;
